"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsingNavThemeArray = exports.CollapsingNavThemeVariants = void 0;
var CollapsingNavThemeVariants;
exports.CollapsingNavThemeVariants = CollapsingNavThemeVariants;

(function (CollapsingNavThemeVariants) {
  CollapsingNavThemeVariants["WHITE"] = "white";
  CollapsingNavThemeVariants["SEASHELL"] = "seashell";
  CollapsingNavThemeVariants["MOCASSIN"] = "mocassin";
  CollapsingNavThemeVariants["DEFAULT"] = "default";
})(CollapsingNavThemeVariants || (exports.CollapsingNavThemeVariants = CollapsingNavThemeVariants = {}));

var CollapsingNavThemeArray = ['white', 'seashell', 'mocassin', 'default'];
exports.CollapsingNavThemeArray = CollapsingNavThemeArray;